import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import './BotaoWhatsApp.css';

/** Suporte da Alpha no WhatsApp: o numero como o formando le, e o link. */
export const TELEFONE_DO_SUPORTE = '(43) 3542-8550';

const NUMERO_DO_SUPORTE = '554335428550';
const MENSAGEM_PARA_O_SUPORTE = 'Olá! Sou formando(a) e preciso de ajuda com o portal.';

export const LINK_DO_SUPORTE =
  `https://wa.me/${NUMERO_DO_SUPORTE}?text=${encodeURIComponent(MENSAGEM_PARA_O_SUPORTE)}`;

/** O balao aparece um pouco depois da tela carregar, para chamar atencao. */
const ATRASO_DO_BALAO_MS = 1500;

/** Fechou o balao? Fica fechado ate o formando abrir o portal de novo. */
const CHAVE_BALAO_FECHADO = 'whatsapp-balao-fechado';

const balaoFoiFechado = () => {
  try {
    return window.sessionStorage.getItem(CHAVE_BALAO_FECHADO) === '1';
  } catch (e) {
    return false;
  }
};

const lembrarBalaoFechado = () => {
  try {
    window.sessionStorage.setItem(CHAVE_BALAO_FECHADO, '1');
  } catch (e) {
    // Sem storage (aba anonima etc.): o balao so some ate a proxima tela.
  }
};

/**
 * Botao flutuante do WhatsApp, so na area do formando: bolinha verde
 * pulsando com um balao de convite ao lado. Os dois abrem a conversa com
 * a Alpha em outra aba. Na tela de compra sobe para nao cobrir o rodape
 * fixo com o Pagar.
 */
const BotaoWhatsApp = ({ usuario, path }) => {
  const ehFormando = Boolean(usuario) && usuario.tipo === 'formando';
  const [balaoAberto, setBalaoAberto] = useState(false);

  useEffect(() => {
    if (!ehFormando || balaoFoiFechado()) return undefined;

    const timer = setTimeout(() => setBalaoAberto(true), ATRASO_DO_BALAO_MS);
    return () => clearTimeout(timer);
  }, [ehFormando]);

  if (!ehFormando) return null;

  const fecharBalao = () => {
    setBalaoAberto(false);
    lembrarBalaoFechado();
  };

  const classe =
    path === '/comprar' ? 'whatsapp-flutuante acima-do-rodape' : 'whatsapp-flutuante';

  return (
    <div className={classe}>
      {balaoAberto && (
        <div className='whatsapp-balao' role='status'>
          <a
            className='whatsapp-balao__mensagem'
            href={LINK_DO_SUPORTE}
            target='_blank'
            rel='noopener noreferrer'
          >
            <strong>Precisa de ajuda?</strong>
            <span>
              Fale com a gente no WhatsApp{' '}
              <span aria-hidden='true'>👋</span>
            </span>
          </a>
          <button
            type='button'
            className='whatsapp-balao__fechar'
            onClick={fecharBalao}
            aria-label='Fechar mensagem'
          >
            &times;
          </button>
        </div>
      )}

      <a
        className='botao-whatsapp'
        href={LINK_DO_SUPORTE}
        target='_blank'
        rel='noopener noreferrer'
        aria-label={`Falar com a Alpha no WhatsApp: ${TELEFONE_DO_SUPORTE}`}
        title={`Fale com a gente no WhatsApp: ${TELEFONE_DO_SUPORTE}`}
      >
        <span className='botao-whatsapp__pulso' aria-hidden='true' />
        <i className='fab fa-whatsapp' aria-hidden='true' />
      </a>
    </div>
  );
};

const mapStateToProps = (state) => ({
  usuario: state.usuario.autenticado,
});

export default connect(mapStateToProps)(BotaoWhatsApp);
